var map = {
	"./ar.png": 1030,
	"./de.png": 1029,
	"./en.png": 1028,
	"./es.png": 1027,
	"./fr.png": 1026,
	"./he.png": 1025,
	"./hu.png": 1024,
	"./icons8-austria.png": 1023,
	"./icons8-canada.png": 835,
	"./icons8-china.png": 1022,
	"./icons8-france.png": 1021,
	"./icons8-germany.png": 834,
	"./icons8-hungary.png": 1020,
	"./icons8-india.png": 833,
	"./icons8-israel.png": 1019,
	"./icons8-italy.png": 1018,
	"./icons8-japan.png": 1017,
	"./icons8-new_zealand.png": 1016,
	"./icons8-saudi_arabia.png": 1015,
	"./icons8-singapore.png": 832,
	"./icons8-south_korea.png": 831,
	"./icons8-usa.png": 1014,
	"./it.png": 1013,
	"./ja.png": 1012,
	"./ko.png": 1011,
	"./ru.png": 1010,
	"./zh.png": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;